class UrlHelperService {
    generateSitemapLink(stationId) {
      const baseURL = 'https://s3.amazonaws.com/upt-prod-s3-eleos/SitemapsAndDipcharts/';
      return `${baseURL}${stationId}/Sitemap-${stationId}.pdf`;
    }
  }
  
export default new UrlHelperService();  